<template>
  <component
    :is="`step-${step}`"
    :safeInfo="safeInfo"
    @setStep="setStep"
    @setSafeInfo="setSafeInfo"
    @next="next"
  />
</template>

<script>
import StatusCheck from "./StatusCheck";
import CreateSafe from "./CreateSafe";
import ConnectSafe from "./ConnectSafe";
import ConnectWallet from "./ConnectWallet";
import Confirm from "./Confirm";

export default {
  components: {
    "step-1": StatusCheck,
    "step-2.1": CreateSafe,
    "step-2.2": ConnectSafe,
    "step-3": ConnectWallet,
    "step-4": Confirm,
  },
  data: () => ({
    safeInfo: {
      safeAddress: null,
      signer: null,
      creator: null,
      owners: null,
      threshold: 0,
    },
    step: "1",
  }),
  methods: {
    setStep(step) {
      this.step = step;
    },
    setSafeInfo(safeInfo) {
      this.safeInfo = {
        ...this.safeInfo,
        ...safeInfo,
      };
    },
    next(address, metadata) {
      this.$emit("next", address, metadata);
    },
  },
};
</script>
